import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface CarouselArrowsProps {
  onPrev: () => void;
  onNext: () => void;
  disabled?: boolean;
}

export default function CarouselArrows({
  onPrev,
  onNext,
  disabled = false,
}: CarouselArrowsProps) {
  const baseClasses =
    'fixed top-1/2 z-10 -translate-y-1/2 rounded-full border border-hairline bg-black/50 p-2 text-white backdrop-blur-md hover:bg-black/60 focus:outline-none focus:ring-2 focus:ring-accent';

  return (
    <>
      <button
        type="button"
        aria-label="Previous"
        className={`${baseClasses} left-4 ${disabled ? 'opacity-50 pointer-events-none' : ''}`}
        onClick={disabled ? undefined : onPrev}
        disabled={disabled}
      >
        <ChevronLeft className="h-6 w-6" />
      </button>
      <button
        type="button"
        aria-label="Next"
        className={`${baseClasses} right-4 ${disabled ? 'opacity-50 pointer-events-none' : ''}`}
        onClick={disabled ? undefined : onNext}
        disabled={disabled}
      >
        <ChevronRight className="h-6 w-6" />
      </button>
    </>
  );
}
